import { render, staticRenderFns } from "./installment-selector.vue?vue&type=template&id=2f5085f6&scoped=true"
import script from "./installment-selector.vue?vue&type=script&lang=ts"
export * from "./installment-selector.vue?vue&type=script&lang=ts"
import style0 from "./installment-selector.vue?vue&type=style&index=0&id=2f5085f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5085f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5085f6')) {
      api.createRecord('2f5085f6', component.options)
    } else {
      api.reload('2f5085f6', component.options)
    }
    module.hot.accept("./installment-selector.vue?vue&type=template&id=2f5085f6&scoped=true", function () {
      api.rerender('2f5085f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/pledge-form/pledge/billingplan/installment-selector.vue"
export default component.exports